import styled from "styled-components";
import { animated } from "@react-spring/web";
import { breakpoints } from "@tvg/design-system";
import { PayoutValuesContainerProps } from "../../type";

export const RunnerResultContainer = styled(animated.div)`
  border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  display: flex;
  padding: 0 ${({ theme }) => theme.space["space-4"]} 11px
    ${({ theme }) => theme.space["space-4"]};
`;

export const SaddleContainer = styled.div`
  max-width: 35px;

  @media screen and ${breakpoints.tablet.max.sm} {
    & > div {
      height: 100%;
      border-radius: 0 0 4px 4px;
    }
  }
`;

export const PayoutContainer = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.space["space-3"]};
  margin-top: ${({ theme }) => theme.space["space-4"]};
`;

export const HorseInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-left: ${({ theme }) => theme.space["space-4"]};
`;

export const PayoutValuesContainer = styled.div<
  Pick<PayoutValuesContainerProps, "numberOfColumns">
>`
  display: grid;
  grid-template-columns: repeat(
    ${({ numberOfColumns }) => numberOfColumns},
    80px
  );
`;

export const PositionContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export const DNF = styled.div`
  width: 30px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2px;
  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.colorTokens.content.subtle};
  color: ${({ theme }) => theme.colorTokens.content.subtle};
  font-size: ${({ theme }) => theme.fontSizes.xs};
`;
